
import { computed, defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "navbar-header-component",
  setup() {
    const store = useStore();
    const navbarTogglerRef = ref<HTMLButtonElement | null>(null);
    let windowWidth = ref(window.innerWidth);

    const account = computed( () => {
      if (!store.getters.isUserAuthenticated)
        return "";
      else
        return store.getters.currentUser.account;
    });

    const subscriberType = computed( () => {
      if (!store.getters.isUserAuthenticated)
        return 0;
      else
        return store.getters.currentUser.subscriberType;
    });

    const onWindowResize = () => windowWidth.value = window.innerWidth;

    onMounted(() => {
      window.addEventListener("resize", onWindowResize)
    });

    onUnmounted(() => {
      window.removeEventListener("resize", onWindowResize);
    })

    const navbarLinkClicked = (() => {
      if (windowWidth.value <= 768) {
        if (navbarTogglerRef.value) navbarTogglerRef.value.click();
      }
    });

    return {
      account,
      subscriberType,
      navbarTogglerRef,

      onMounted,
      onUnmounted,

      navbarLinkClicked
    }
  }
});
